import state from './informacastmessage.state'
import mutations from './informacastmessage.mutations'
import actions from './informacastmessage.actions'

export default {
  state,
  mutations,
  actions
}
